import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, MenuItem, Select, Typography, useTheme } from "@mui/material";
import { Circle } from "@mui/icons-material";
import { FaSquareFull } from "react-icons/fa6";

const FinancialProgress = (props) => {
    const { data } = props
    const theme = useTheme();
    let options = {
        chart: {
            type: "solidgauge",
            height: '100%',
            backgroundColor: 'transparent'
        },
        title: {
            text: "",
            style: { fontSize: "18px" },
        },
        pane: {
            size: '100%',
            startAngle: 0,
            endAngle: 360,
            center: ['52%', '50%'],
            background: [
                {
                    outerRadius: "",
                    innerRadius: "88%",
                    backgroundColor: Highcharts.color("#295477").setOpacity(0.3).get(),
                    borderWidth: 0,
                },
                {
                    outerRadius: "",
                    innerRadius: "63%",
                    backgroundColor: Highcharts.color("#90ed7d").setOpacity(0.3).get(),
                    borderWidth: 0,
                },
                {
                    outerRadius: "",
                    innerRadius: "38%",
                    backgroundColor: Highcharts.color("#E72B33").setOpacity(0.3).get(),
                    borderWidth: 0,
                },
            ],
        },
        yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            tickPositions: [],
        },
        plotOptions: {
            solidgauge: {
                dataLabels: {
                    enabled: false,
                },
                linecap: "round",
                stickyTracking: false,
            },
        },
        tooltip: {
            enabled: false
        },
        legend: {
            enabled: false,
            align: "center",
            verticalAlign: "bottom",
            layout: "horizontal",
        },
        series: data,
        credits: {
            enabled: false,
        },
    };

    return (
        <Box sx={{ mt: 1, padding: 2, pb: 0, border: '1px solid #2525252E', borderRadius: '7px', minHeight: '230px', background: "#FFFFFF" }}>
            <Grid2 container>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        Financial Progress - Plan vs Actual
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '14px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        Compare financial progress against planned
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <List sx={{ padding: 0, mt: 2 }}>
                        {/* <ListItem sx={{
                            paddingLeft: 1
                        }}>
                            <ListItemIcon sx={{ minWidth: '25px' }}>
                                <FaSquareFull style={{ color: '#E8E3E3', height: '14px', width: '14px' }} />
                            </ListItemIcon>
                            <ListItemText primary={"Overall: 55%"} sx={{
                                color: "#182A4E",
                                '& .MuiTypography-root': {
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px'
                                }

                            }} />
                        </ListItem> */}
                        {data?.map((val, index) => {
                            if (index != 0) {
                                return <ListItem sx={{
                                    paddingLeft: 0, whiteSpace: "nowrap"
                                }}>
                                    <ListItemIcon sx={{ minWidth: '25px' }}>
                                        <FaSquareFull style={{ color: `${val?.data[0]?.color}`, height: '14px', width: '14px' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={`${val?.name}: ${val?.data[0]?.y}%`} sx={{
                                        color: "#182A4E",
                                        '& .MuiTypography-root': {
                                            fontWeight: 500,
                                            fontSize: '16px',
                                            lineHeight: '100%',
                                            letterSpacing: '-0.4px'
                                        }

                                    }} />
                                </ListItem>
                            }

                        })}
                        {/* <ListItem sx={{
                            paddingLeft: 1
                        }}>
                            <ListItemIcon sx={{ minWidth: '25px' }}>
                                <FaSquareFull style={{ color: '#415385', height: '14px', width: '14px' }} />
                            </ListItemIcon>
                            <ListItemText primary={"Planned: 9.7%"} sx={{
                                color: "#182A4E",
                                '& .MuiTypography-root': {
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px'
                                }

                            }} />
                        </ListItem>
                        <ListItem sx={{
                            paddingLeft: 1
                        }}>
                            <ListItemIcon sx={{ minWidth: '25px' }}>
                                <FaSquareFull style={{ color: '#CB402D', height: '14px', width: '14px' }} />
                            </ListItemIcon>
                            <ListItemText primary={"Actual: 9.3%"} sx={{
                                color: "#182A4E",
                                '& .MuiTypography-root': {
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px'
                                }

                            }} />
                        </ListItem> */}
                    </List>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <HighchartsReact highcharts={Highcharts} options={options} />
                </Grid2>
            </Grid2>
        </Box>

    );
};

export default FinancialProgress;
